import React from "react";
import axios from "axios";
import GoogleLogin from "react-google-login";
import googleAuthenticationConfig from "../../utils/googleAuthenticationConfig";
import Cookies from "js-cookie";
import { parseAxiosError } from "../../utils/response";
import { STANDARD_ERRORS_WAY } from "../../utils/consts";

const GoogleForm = ({authData, setAuthData, error, notification, setNotification, selectedLanguage, t}) => {

    const responseGoogle = (response) => {
        if (!response.tokenId || !response.profileObj) {
            return;
        }

        const token = response.tokenId;

        let data = {
            email: response.profileObj.email,
            responseGoogleToken: token
        };

        axios.post("/api", {}, googleAuthenticationConfig(data.responseGoogleToken)).then(response => {
            if (response.status === 200) {
                setAuthData({
                    ...authData,
                    responseGoogleToken: data.responseGoogleToken,
                    authConfig: googleAuthenticationConfig(data.responseGoogleToken)
                });
            }
            if (response.status === 201) {
                Cookies.set("token", response.data.data.attributes.token);
                if (Cookies.get("token")) {
                    window.location.href = "/";
                }
            }
        }).catch(error => {
            parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
        });
    };

    return (
        <div className="login-with-google">
            <GoogleLogin
                clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
                render={renderProps => (
                    <button
                        onClick={renderProps.onClick}
                        disabled={renderProps.disabled}
                        color="primary"
                        type="submit"
                        className="login-with-google__button"
                    >
                        <span className="icon-social-google"/>
                    </button>
                )}
                onSuccess={responseGoogle}
                onFailure={responseGoogle}
                cookiePolicy={"single_host_origin"}
            />
            <p className="login-with-google__text">
                {t("useEmailForLogin")}
            </p>
        </div>
    );
};

export default GoogleForm;